module.exports = __webpack_public_path__ + "img/build_en.07853a2d.png";